<template>
  <div>
    <div class="tableTop">
      <div class="operationButton">
        <el-button type="primary" size="small" @click="ruleUpdate()"
          >添加标签组</el-button
        >
      </div>
      <div
        style="transform: translateY(5px)"
        class="fixed"
        @click="synchronization"
        v-if="$store.state.app.myStoreCur.is_corp != 1"
      >
        <el-button type="primary" size="small">同步</el-button>
      </div>
    </div>
    <section>
      <el-card class="box-card label" v-if="labelList.length">
        <div v-for="(item, index) in labelList" :key="index" class="labelBox">
          <div class="lt">
            <h4>{{ item.title }}</h4>
            <span>共{{ item.children_data.length }}个标签</span>
          </div>
          <div class="ct">
            <!-- <p>可见范围：全部员工可见</p> -->
            <el-button
              size="mini"
              icon="el-icon-plus"
              style="margin:10px 10px 0 0"
              @click="addLabel(item.id, index)"
              >添加</el-button
            >
            <div
              style="width:140px;display:inline-block;margin-right:10px"
              v-if="item.on_show"
            >
              <el-input
                ref="inps"
                size="mini"
                @change="changeInp(item)"
                @blur="
                  () => {
                    item.on_show = false
                  }
                "
                v-model="inp"
                placeholder="输入完请按回车"
              ></el-input>
            </div>
            <el-button
              size="mini"
              style="margin:10px 10px 0 0"
              v-for="(tiem, index) in item.children_data"
              :key="index"
              >{{ tiem.title }}</el-button
            >
          </div>

          <div class="rt">
            <el-button
              size="small"
              type="text"
              icon="el-icon-upload2"
              @click="groupSorts(item.id, up)"
              :disabled="index ? false : true"
              >上移</el-button
            >
            <el-divider direction="vertical"></el-divider>
            <el-button
              size="small"
              type="text"
              icon="el-icon-download"
              :disabled="index == labelList.length - 1 ? true : false"
              @click="groupSorts(item.id, down)"
              >下移</el-button
            >
            <el-divider direction="vertical"></el-divider>
            <el-button
              size="small"
              type="text"
              icon="el-icon-edit-outline"
              @click="ruleUpdate(item)"
              >编辑</el-button
            >
            <el-divider direction="vertical"></el-divider>
            <el-button
              size="small"
              type="text"
              icon="el-icon-delete"
              @click="labelDel(item.id)"
              >删除</el-button
            >
          </div>
        </div>
      </el-card>
      <el-empty v-else description="暂无标签组"></el-empty>

      <!-- 信息更新-->
      <el-dialog
        title="标签组更新"
        custom-class="listDialog"
        width="500px"
        :visible.sync="rightDialog"
        @close="off"
      >
        <el-form
          :model="rtRequestData"
          ref="leftTabForm"
          label-width="100px"
          class="listForm"
        >
          <el-form-item
            label="标签组名称"
            prop="title"
            :rules="[{ required: true, message: '标签组名称不能为空' }]"
          >
            <el-input v-model="rtRequestData.title"></el-input>
          </el-form-item>
          <el-form-item prop="id" v-show="false">
            <el-row>
              <el-col :span="15">
                <el-input v-model="rtRequestData.id"></el-input>
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item label="标签名称">
            <el-row
              v-for="(item, index) in rtRequestData.labelList"
              :key="index"
              type="flex"
              :gutter="30"
            >
              <el-col style="width:700px; margin-bottom:10px">
                <el-input v-model="item.title"></el-input>
              </el-col>
              <el-col>
                <el-button
                  size="small"
                  type="text"
                  icon="el-icon-delete"
                  @click="dialDel(index)"
                ></el-button>
                <el-divider direction="vertical"></el-divider>
                <el-button
                  size="small"
                  type="text"
                  icon="el-icon-upload2"
                  :disabled="index ? false : true"
                  @click="groupSortsDia(index, up)"
                ></el-button>
                <el-divider direction="vertical"></el-divider>
                <el-button
                  size="small"
                  type="text"
                  icon="el-icon-download"
                  :disabled="
                    index == rtRequestData.labelList.length - 1 ? true : false
                  "
                  @click="groupSortsDia(index, down)"
                ></el-button>
              </el-col>
            </el-row>
            <div class="diaBt">
              <el-button
                type="text"
                icon="el-icon-circle-plus-outline"
                @click="addDia"
                >添加标签</el-button
              >
              <el-button type="text" @click="labelDel(rtRequestData.id)"
                >删除标签组</el-button
              >
            </div>
          </el-form-item>
        </el-form>

        <div slot="footer" class="dialog-footer">
          <el-button
            type="primary"
            size="small"
            @click="submitForm('leftTabForm')"
            >确 定</el-button
          >
        </div>
      </el-dialog>
    </section>
  </div>
</template>
<script>
export default {
  data() {
    return {
      rtRequestData: {
        id: '',
        title: '', //标签名称
        labelList: [
          {
            id: '',
            title: '',
            sort: 1,
          },
        ],
      },
      rightDialog: false,
      inp: '',
      up: 'up',
      down: 'down',
      labelList: [],
    }
  },
  mounted() {
    this.getLabelList()
  },
  methods: {
    async synchronization() {
      this.isLoading = true
      await this.$api.synchroLabel()
      this.getLabelList()
      this.$commonFun.toast('同步成功', 'success')
    },
    off() {
      this.$refs.leftTabForm.resetFields()
      this.rtRequestData.labelList = []
      this.rtRequestData.labelList.push({
        id: '',
        title: '',
        sort: '',
      })
    },
    ruleUpdate(item) {
      //更新
      this.rightDialog = true
      this.$nextTick(() => {
        if (item) {
          this.rtRequestData.id = item.id
          this.rtRequestData.title = item.title
          this.rtRequestData.labelList = JSON.parse(
            JSON.stringify(item.children_data)
          )
        }
      })
    },
    addDia() {
      //表单添加标签
      this.rtRequestData.labelList.push({
        id: '',
        title: '',
        sort: '',
      })
    },
    dialDel(index) {
      //表单删除
      this.rtRequestData.labelList.splice(index, 1)
    },
    changeInp(item) {
      item.on_show = false
      if (this.inp) {
        var param = {
          id: '',
          title: this.inp,
          group_id: item.id,
        }
        this.$api.labeAdd(param).then((res) => {
          item.children_data.push(res)
          this.inp = ''
          item.on_show = false
        })
      }
    },
    addLabel(id, index) {
      //添加标签
      this.labelList[index].on_show = !this.labelList[index].on_show
      this.$nextTick(() => {
        if (this.labelList[index].on_show) this.$refs.inps[0].focus()
      })
    },
    async getLabelList() {
      //获取标签列表
      const res = await this.$api.getLabel()
      this.labelList = res
    },
    labelDel(id) {
      if (id) {
        let _self = this
        _self
          .$confirm('确定删除该分组吗？此操作不可逆！', '提示')
          .then((result) => {
            _self.$api
              .LabelDel({
                id,
              })
              .then((res) => {
                _self.$commonFun.toast('删除成功', 'success')
                _self.getLabelList()
                _self.$nextTick(() => {
                  _self.rightDialog = false
                  this.off()
                })
              })
          })
      }
    },
    // 排序
    groupSorts(id, sort) {
      let _self = this
      _self.$commonFun.debounce(async () => {
        let param = { id, type: sort }
        const res = await _self.$api.groupSort(param)
        let index = _self.labelList.findIndex((item) => item.id == id)
        if (sort == 'up' && index) {
          let item = _self.labelList.splice(index, 1)
          _self.labelList.splice(index - 1, 0, item[0])
        }
        if (sort == 'down' && index !== _self.labelList.length - 1) {
          let item = _self.labelList.splice(index, 1)
          _self.labelList.splice(index + 1, 0, item[0])
        }
      })
    },
    //排序
    groupSortsDia(index, sort) {
      if (sort == 'up' && index) {
        let item = this.rtRequestData.labelList.splice(index, 1)
        this.rtRequestData.labelList.splice(index - 1, 0, item[0])
      }
      if (sort == 'down' && index !== this.rtRequestData.labelList.length - 1) {
        let item = this.rtRequestData.labelList.splice(index, 1)
        this.rtRequestData.labelList.splice(index + 1, 0, item[0])
      }
    },
    //更新
    submitForm(leftTabForm) {
      let _self = this
      _self.$commonFun.debounce(() => {
        _self.$refs[leftTabForm].validate((valid) => {
          if (valid) {
            let param = _self.rtRequestData
            _self.$api.groupLabelUpdate(param).then((res) => {
              _self.rightDialog = false
              _self.$commonFun.toast('SUCCESS', 'success')
              // if (param.id) _self.getImgList(_self.search.page)
              // else { _self.getImgList() }
              this.getLabelList()
            })
          }
        })
      }, 500)
    },
  },
}
</script>
<style lang="scss">
.tableTop {
  position: relative;
}
.box-card.label {
  min-height: calc(100vh - 150px);
}
.labelBox {
  height: auto;
  overflow: hidden;
  border-top: 1px solid #dcdfe6;
  &:first-child {
    border-top: none;
  }
  padding: 15px 0 20px;
  .lt {
    float: left;
    width: 200px;
    margin: 10px 30px 0 0;
    h4 {
      margin-bottom: 30px;
    }
  }
  .rt {
    width: 230px;
    float: right;
    margin-top: 2px;
  }
  .ct {
    width: calc(100% - 500px);
    float: left;
    p {
      margin-bottom: 30px;
    }
  }
}
</style>
